import { AlertDialogArgs, ConfirmDialogArgs, Dialog, DialogUtility } from '@syncfusion/ej2-popups';
import { BehaviorSubject } from 'rxjs';

const syncfusionDialogUtilitySubject = new BehaviorSubject<Dialog | null>(null);

const originalConfirm = DialogUtility.confirm;
const originalAlert = DialogUtility.alert;

const syncfusionDialogUtilityService = {
    configureDialogUtility: () => {
        DialogUtility.confirm = (args?: ConfirmDialogArgs | string): Dialog => {
            const dialog = originalConfirm.call(DialogUtility, args);
            syncfusionDialogUtilitySubject.next(dialog);

            dialog.addEventListener('close', () => syncfusionDialogUtilitySubject.next(null));
            dialog.addEventListener('destroyed', () => syncfusionDialogUtilitySubject.next(null));

            return dialog;
        };

        DialogUtility.alert = (args?: AlertDialogArgs | string): Dialog => {
            const dialog = originalAlert.call(DialogUtility, args);
            syncfusionDialogUtilitySubject.next(dialog);

            dialog.addEventListener('close', () => syncfusionDialogUtilitySubject.next(null));
            dialog.addEventListener('destroyed', () => syncfusionDialogUtilitySubject.next(null));

            return dialog;
        };
    },
    closeDialog: () => {
        const dialog = syncfusionDialogUtilitySubject.getValue();
        if (dialog) {
            dialog.hide();
            dialog.destroy();
            syncfusionDialogUtilitySubject.next(null);
        }
    },
};

export { syncfusionDialogUtilityService };
